module.exports = __webpack_public_path__ + "static/media/main.0bb13591.png";